import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import CustomToast from "src/components/CustomToast/CustomToast";
import formatApiError from "src/features/Navigation/utils/formatApiError";
import cmsClient from "src/services/cmsClient";

interface EditNavigationItemOptions {
	id: string;
	payload: Record<string, unknown>;
}

const editNavigationItem = async ({
	id,
	payload
}: EditNavigationItemOptions) => {
	const url = `/homepage/admin/mobilenavigation/${id}/`;
	const response = await cmsClient.patch<INavigationItem>(url, payload);

	return response.data;
};

const useEditNavigationItem = () => {
	const queryClient = useQueryClient();

	const onSuccess = () => {
		toast.success(
			<CustomToast type="Success" message="Navigation item updated" />,
			{ hideProgressBar: true }
		);
	};

	const onError = (error: any) => {
		const message = formatApiError(error?.response?.data);
		toast.error(<CustomToast type="Error" message={message} />, {
			hideProgressBar: true
		});
	};

	const onSettled = () => {
		queryClient.invalidateQueries(["navigation-items"]);
	};

	const mutation = useMutation(editNavigationItem, {
		onSuccess,
		onError,
		onSettled
	});

	return mutation;
};

export default useEditNavigationItem;
